import type { ReactNode } from 'react';
import styled from 'styled-components';

import { CloseButton } from '@sorare/core/src/atoms/buttons/CloseButton';
import { Centered } from '@sorare/core/src/atoms/layout/Centered/index.tsx';
import { BrandS } from '@sorare/core/src/atoms/typography/index.tsx';

const StyledCentered = styled(Centered)`
  padding: var(--unit) var(--double-unit);
`;

type Props = {
  children: ReactNode;
  onClose: () => void;
};

export const PickerHeader = ({ children, onClose }: Props) => {
  return (
    <StyledCentered
      right={<CloseButton onClose={onClose} transparent size="small" />}
    >
      <BrandS color="var(--c-white)" className="text-center">
        {children}
      </BrandS>
    </StyledCentered>
  );
};
